// store/modules/readByUserId.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ReadByUserIdService} from "../../service/ReadByUserIdService.ts";
import {ReadByUserIdResponse} from "../../model/response/ReadByUserIdResponse";
import {store} from "../index.ts";

interface ReadByUserIdState {
    userInfo: ReadByUserIdResponse | null;
    loading: boolean;
}

const initialState: ReadByUserIdState = {
    userInfo: null,
    loading: false,
};

export const readReadByUserId = createAsyncThunk(
    "readByUserId/read",
    async (_payload: any) => {
        const response = await ReadByUserIdService.read(_payload);
        return response.data;
    }
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const readByUserIdSlice = createSlice({
    name: "readByUserId",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(readReadByUserId.pending, (state) => {
                state.loading = true;
            })
            .addCase(
                readReadByUserId.fulfilled,
                (state, action: PayloadAction<ReadByUserIdResponse>) => {
                    state.loading = false;
                    state.userInfo = action.payload;
                }
            )
            .addCase(readReadByUserId.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const readByUserIdReducer = readByUserIdSlice.reducer;
export const readByUserIdActions = readByUserIdSlice.actions;
